import { Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LOCATION_INITIALIZED } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
declare var instituicaoConstants: { LINGUAGEM: any; };

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

export function ApplicationInitializerFactory(translate: TranslateService, injector: Injector) {
  return async () => {
    await injector.get(LOCATION_INITIALIZED, Promise.resolve(null));

    let deaultLang = instituicaoConstants.LINGUAGEM ? instituicaoConstants.LINGUAGEM : 'pt-BR';

    translate.setDefaultLang(deaultLang);

    try {
      await translate.use(deaultLang).toPromise();
    } catch (err) {
      console.error(err);
    }
  };
}